export const primary = "#0182ff";
export const one = "#0de49d";
export const two = "#f5faff";
export const font1 = "#4a4a4a";
export const font2 = "#666666";
export const disable1 = "#ccc";
export const disable2 = "lightgray";
export const background1 = "#f3f3f3";
export const darkGray = "#666666";
export const white = "#ffffff"